import { useSankeyRenderContext } from '../../contexts/sankeyRenderContext';
import { ep } from '../../diagram/numbers';
import { SankeyNode } from '../../diagram/types';

interface Props {
  node: SankeyNode;
}

const SankeyDraggedNodeLines: React.FC<Props> = ({ node }) => {
  const { cfg, graph } = useSankeyRenderContext();

  // Draw 4 horizontal/vertical guide lines, along the edges of the place where the drag began (node.lastPos)
  return (
    <path
      id="helper_lines"
      // This SVG Path spec means:
      // [M]ove to the left edge of the graph at this node's top
      // [h]orizontal line across the whole graph width
      // [m]ove down by this node's height
      // [H]orizontal line back to the left edge (x=0)
      // ..Then the same operation [v]ertically, using this node's width.
      d={
        `M0 ${ep(node.lastPos?.y)} h${ep(graph.w)} m0 ${ep(node.dy)} H0` +
        `M${ep(node.lastPos?.x)} 0 v${ep(graph.h)} m${ep(node.dx)} 0 V0`
      }
      fill={cfg.hint.color}
      fillOpacity={0.5}
      stroke={cfg.hint.color}
      strokeWidth={1}
      strokeDasharray="1 3"
      strokeOpacity={0.7}
    />
  );
};

export default SankeyDraggedNodeLines;
